import { Updater } from "use-immer";

import { ConfigType, ConfigurationDto } from "@intelligems/ig-types";

import { genericSort } from "../../../utils/sortings";

export function sortSettings(settings: ConfigurationDto[]) {
  const optionOrder: Record<ConfigType, number> = {
    Boolean: 1,
    String: 2,
    Integer: 3,
    Float: 4,
    Json: 5,
    List: 6,
  };

  [...settings]
    .sort((a, b) => genericSort(a, b, "key"))
    .sort(({ type: typeA }, { type: typeB }) => {
      if (typeof typeA === "undefined" || typeof typeB === "undefined") {
        return 0;
      }
      const a = optionOrder[typeA];
      const b = optionOrder[typeB];

      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    });

  return settings;
}

// replace current value with new value
export const onConfigChange = (
  key: string,
  newVal: any,
  setSettingsState: Updater<ConfigurationDto[]>
) => {
  setSettingsState((draft) => {
    const index = draft.findIndex((config) => config.key === key);
    draft[index].value = newVal;
    return draft;
  });
};

export const getNewModifiedConfigs = (
  settingsState: ConfigurationDto[],
  configurations: ConfigurationDto[]
): ConfigurationDto[] => {
  return settingsState.filter(
    (config: ConfigurationDto) =>
      JSON.stringify(config.value) !==
      JSON.stringify(configurations.find((c) => c.key === config.key)?.value)
  );
};
